import { createAsyncThunk } from "@reduxjs/toolkit";
import { caseChecklistDocumentsVerificationAPI } from "../../../api/caseChecklistTab_api";

export const caseChecklistVerificationAction = createAsyncThunk(
  "checklist/caseChecklistVerification",
  async (caseID, { rejectWithValue }) => {
    const response = await caseChecklistDocumentsVerificationAPI(caseID);

    if (!response.success) {
      return rejectWithValue(response.error);
    }

    return response.data;
  },
);
